import React from "react";
import { Result, Button } from "antd";
import { MASTER_DATA_SERVER } from "swfrontend/AppConfigs";
import {
  METHOD_POST,
  CORS_SETTINGS,
  CACHE_SETTINGS,
  STANDARD_METHOD_OPTIONS,
} from "swfrontend/COMS/Utils/ApiCommunicaton";
import getCookie from "swfrontend/COMS/Utils/cookies";
import NavbarLogo from "swfrontend/UI/NavBar/NavbarLogo";

export const SERVER = MASTER_DATA_SERVER;
const BASE_URL = `${process.env.REACT_APP_SERVER_PROTOCOL}://${SERVER.SERVER_URL}:${SERVER.PORT}/${SERVER.API_PREFIX}`;

/**
 * To log child component errors and display common error web page when application crashes
 */
class ErrorHandler extends React.Component {
  state = { hasError: false };

  componentDidCatch(error, errorInfo) {
    // To catch child component errors and log them to backend
    this.setState({ hasError: true }, () => {
      ErrorLogger({
        error: error.toString(),
        trackback: errorInfo.componentStack,
      });
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <ErrorPage />;
    }
    return this.props.children;
  }
}
export default ErrorHandler;

/**
 * ErrorPage to be display when application crashes
 */
class ErrorPage extends React.Component {
  render() {
    return (
      <>
        <div className="error-handler-header">
          <NavbarLogo />
        </div>
        <br />
        <br />
        <Result
          status="500"
          title="Something went wrong, please try again or contact AM/NS Team"
          subTitle=""
          extra={
            <Button
              type="primary"
              onClick={() =>
                (window.location.href =
                  process.env.REACT_APP_PROJECT_ROUTE !== "/null"
                    ? process.env.REACT_APP_PROJECT_ROUTE
                    : "/")
              }
            >
              Back Home
            </Button>
          }
        />
      </>
    );
  }
}

/**
 * This function will report error to backend logger
 * @param {str} error Error message in string
 */
export const ErrorLogger = (error) =>
  fetch(`${BASE_URL}/${process.env.REACT_APP_API_MASTER_ROUTE}/error-handler`, {
    ...STANDARD_METHOD_OPTIONS,
    ...CACHE_SETTINGS,
    ...CORS_SETTINGS,
    method: METHOD_POST,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": getCookie(
        `${process.env.REACT_APP_TOKEN_PREFIX}-csrftoken`
      ),
    },
    body: JSON.stringify({
      error: error,
      datetime: new Date().toString(),
    }),
  });
